export enum DeepLinkCommandName {
    OpenChat = 'open_chat',
}

export type DeepLinkCommandNameMap = {
    [key in DeepLinkCommandName]: (params: URLSearchParams) => void;
};
